import React, {useRef, useState, useEffect} from "react";

import "./FileUpload.css";

import Button from "./Button";

const FileUpload = (props) => {
  const [file, setFile] = useState();
  const [isValid, setIsValid] = useState({
    state: false,
    message: "Select PDF, JPG or PNG file only...",
  });
  const filePickerRef = useRef();

  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = isValid.state;
    if (event.target.files && event.target.files.length === 1) {
      let filename = event.target.files[0].name;
      const ext = filename.split(".").pop()?.toLowerCase();
      console.log(`File Type ====> ${ext}`);
      if (!["pdf", "jpeg", "jpg", "png"].includes(ext)) {
        setIsValid({
          state: false,
          message: "Incorrect file type, must be a PDF, PNG or JPG file...",
        });
        fileIsValid = false;
      } else if (event.target.files[0].size > 250000) {
        setIsValid({
          state: false,
          message: "File too large, please upload a file lesser than 250 KB",
        });
        fileIsValid = false;
      } else {
        pickedFile = event.target.files[0];
        setFile(pickedFile);
        props.setFileName(pickedFile);
        setIsValid({
          state: true,
          message: pickedFile.name,
        });
        fileIsValid = true;
      }
    } else {
      setIsValid({
        state: false,
        message: "Select PDF, JPG or PNG file only...",
      });
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  const filePickerHandler = () => {
    filePickerRef.current.click();
  };

  useEffect(() => {
    if (props.file) {
      setFile(props.file);
      props.setFileName(props.file);
    } else {
      setFile(null);
      props.setFileName(null);
    }
  }, [props.file, props.setFileName]);

  return (
    <div className="filepicker">
      <input
        type="file"
        id={props.id}
        ref={filePickerRef}
        style={{display: "none"}}
        accept={props.accept ? props.accept : ".pdf, .png, .jpg, .jpeg"}
        onChange={pickedHandler}
      ></input>
      <h6>{isValid.message}</h6>
      <Button
        type="button"
        disabled={props.disabled}
        onClick={filePickerHandler}
      >
        Choose File
      </Button>
    </div>
  );
};

export default React.memo(FileUpload);
